module.exports = __webpack_public_path__ + "img/mi4.48c065db.png";